import type { IMdEdit } from './IMdEdit';

/** Обгортає виділення (або текст-заповнювач) маркерами: **жирний**, *курсив*, `код`, {колір|…}, ==…==; виділяє обгорнутий текст. */
export function mdWrap(body: string, s0: number, s1: number, before: string, after: string, placeholder: string): IMdEdit {
  const sel = body.slice(s0, s1) || placeholder;
  return { text: body.slice(0, s0) + before + sel + after + body.slice(s1), start: s0 + before.length, end: s0 + before.length + sel.length };
}

/** Префікс кожного рядка виділення (## , ### , - , 1. , > ); попередній префікс знімається, нумерація — 1. 2. 3. */
export function mdPrefixLines(body: string, s0: number, s1: number, prefix: string): IMdEdit {
  const ls = body.lastIndexOf('\n', s0 - 1) + 1;
  const le = body.indexOf('\n', s1);
  const end = le < 0 ? body.length : le;
  const block = body.slice(ls, end).split('\n')
    .map((l, i) => (prefix === '1. ' ? `${i + 1}. ` : prefix) + l.replace(/^(#{1,3}\s|[-*]\s|\d+\.\s|>\s)/, '')).join('\n');
  return { text: body.slice(0, ls) + block + body.slice(end), start: ls, end: ls + block.length };
}

/** Вставляє фрагмент на місце виділення; блок (таблиця, запит) починається з нового рядка; курсор — після вставленого. */
export function mdInsert(body: string, s0: number, s1: number, fragment: string, block = false): IMdEdit {
  const pre = block && s0 > 0 && body[s0 - 1] !== '\n' ? '\n' : '';
  const pos = s0 + pre.length + fragment.length;
  return { text: body.slice(0, s0) + pre + fragment + body.slice(s1), start: pos, end: pos };
}

/** Кількість слів і хвилин читання (200 слів за хвилину, щонайменше 1) — підвал редактора. */
export function mdStats(body: string): { words: number; minutes: number } {
  const words = body.trim() ? body.trim().split(/\s+/).length : 0;
  return { words, minutes: Math.max(1, Math.round(words / 200)) };
}
